import type { FieldNode } from 'graphql';

export const getFieldAliasOrName = (field: FieldNode) => field.alias?.value ?? field.name?.value;
